import React, { useEffect, useState } from 'react';
import './CreatorOnboarding.scss';

import _ from 'lodash';
import CreatorOnboardingBackgroundImage, { CreatorOnboardingBackgroundImageStyle } from '../../Components/CreatorOnboarding/CreatorOnboardingBackgroundImage';
import CreatorOnboardingRegistrationCodePanel from '../../Components/CreatorOnboarding/CreatorOnboardingRegistrationCodePanel';
import { preloadImages } from '../../Helpers/image_helpers';
import { CREATOR_ONBOARDING_BACKGROUND_IMAGE_URL } from '../../Components/CreatorOnboarding/CreatorOnboardingBackgroundImage';
import CreatorOnboardingWelcomePanel from '../../Components/CreatorOnboarding/CreatorOnboardingWelcomePanel';
import { withRouter } from 'react-router-dom';

const CreatorOnboarding = props => {
  const [activePanelIndex, setActivePanelIndex] = useState(0);
  const [backgroundImageLoaded, setBackgroundImageLoaded] = useState(false);
  const [onboardingData, setOnboardingData] = useState({});

  const panels = [
    {
      name: 'Registration Code',
      backgroundImageStyle: CreatorOnboardingBackgroundImageStyle.FULL_WIDTH_CLEAR,
      Component: CreatorOnboardingRegistrationCodePanel,
    },
    {
      name: 'Welcome',
      backgroundImageStyle: CreatorOnboardingBackgroundImageStyle.FULL_WIDTH_BLURRED,
      Component: CreatorOnboardingWelcomePanel,
    },
  ];

  useEffect(() => {
    // TODO(ross): Remove after launch
    if (!window.__IS_NEW_CREATOR_ONBOARDING_LIVE__) {
      props.history.push('/apply/creator');
    }
    if (!backgroundImageLoaded) {
      preloadImages(CREATOR_ONBOARDING_BACKGROUND_IMAGE_URL).then(() => setBackgroundImageLoaded(true));
    }
  }, [backgroundImageLoaded]);

  const {
    Component,
    backgroundImageStyle
  } = panels[activePanelIndex];

  const goToNextPanel = () => {
    if (activePanelIndex >= panels.length - 1) return;
    setActivePanelIndex(activePanelIndex + 1);
  }

  const updateOnboardingData = (updates) => {
    setOnboardingData({...onboardingData, ...updates});
  }

  const panelProps = {
    goToNextPanel,
    updateOnboardingData,
    onboardingData
  }

  return (
    <div className='creator-onboarding-outer-container'>
      <div className='creator-onboarding-inner-container'>
        {backgroundImageLoaded && <CreatorOnboardingBackgroundImage backgroundImageStyle={backgroundImageStyle} />}
        {backgroundImageLoaded && Component && <Component {...panelProps} />}
      </div>
    </div>
  );
};



export default withRouter(CreatorOnboarding);
